export default "__VITE_ASSET__gs1Fq2nS__"